<ul class="selected-items"></ul>
<ul class="total-selected">
    <li><span>0</span> {{locale "selected"}}</li>
</ul>
<div class="selection-tooltip"></div>

